<template>
  <div class="container mx-auto mt-28">
    <div class="text-center">
      <h1>Clip</h1>
      <h2><small>Someone shared this clipboard with you</small></h2>
      <textarea readonly class="my-4" ref="contentArea" v-model="state.clip.content"></textarea>
    </div>
    <div class="flex justify-between px-4 my-4">
      <span></span>
      <button @click="copy">Copy</button>
    </div>
  </div>


</template>

<script setup>
import {reactive, ref, onMounted, computed} from 'vue'
import http from '../../helpers/http.js'

let props = defineProps({
  clip: Object
})

console.log({clip: props.clip})
let state = reactive({clip: props.clip})

let copy = () => {
  navigator.clipboard.writeText(state.clip.content)
}
</script>

<style>

</style>